import windowHelpers from "shared/utils/windowHelpers";

export function errorMessage({ message, graphQLErrors = [], networkError }) {
  const { message: errorMessage } = networkError || graphQLErrors[0] || { message };

  return errorMessage;
}

export function withErrorMessage(callback) {
  return error => callback(errorMessage(error));
}

export function withRedirectOnUnauthorized(callback) {
  return error => {
    const { networkError } = error;
    if (networkError && networkError.statusCode === 401) {
      const { errors } = networkError.result || {};
      const [{ links } = {}] = errors || [];
      const { login } = links || {};

      if (login) {
        windowHelpers.navigateTo(links.login);
      } else {
        callback(error);
      }
    } else {
      callback(error);
    }
  };
}
